/**
 * Mutation hooks for ActivityLog operations
 * Replaces save() and delete() methods on ActivityLog model
 */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ActivityLog, newActivityLog, toActivityLogPayload } from '../Model/Activity/ActivityLog';
import { useBackend } from './useBackend';

export function useSaveActivityLog() {
  const backend = useBackend();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (activityLog: ActivityLog) =>
      backend.post('/activity/tracking', toActivityLogPayload(activityLog)).then((res: any) => {
        return newActivityLog(res);
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['activityLog'] });
      queryClient.invalidateQueries({ queryKey: ['activitySchedule'] });
    },
  });
}

export function useDeleteActivityLog() {
  const backend = useBackend();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (activityLog: ActivityLog) =>
      backend.delete(`/activity/tracking/${activityLog.id}`).then(() => activityLog),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['activityLog'] });
      queryClient.invalidateQueries({ queryKey: ['activitySchedule'] });
    },
  });
}
